// src/routes/PrivateRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';

// Read the (unverified) JWT payload. Purely for routing UX — the backend is the
// authority and rejects protected calls with 428 regardless of what we do here.
const readTokenClaims = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return {};
  }
};

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();
  if (!token) return <Navigate to="/login" />;

  // A PASSWORD_EXPIRY login policy stamps `pwdChange` on the token: send the
  // user to the forced change-password screen instead of a page whose data
  // calls would all come back 428.
  const mustChangePassword = !!readTokenClaims(token).pwdChange;
  if (mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return children;
};

export default PrivateRoute;
